/**
 * DEV-ONLY Break Glass detail/thread fixtures (CT-5096) — opt-in via localStorage.
 *
 * Mirrors EVT-004 body for live contracts (e.g. wq5096-breakglass-001) when Platform
 * `render` is sparse. Approvers start **both pending** so QA can exercise 1 of 2 → 2 of 2
 * (the aims-htl EVT-004 mock keeps Devon confirmed for the static prototype snapshot).
 *
 *   Enable :  localStorage.setItem('wq_enrich_break_glass', '1')   // then reload
 *   Disable:  localStorage.removeItem('wq_enrich_break_glass')
 */

import { mergeFixtureDetail } from './fixtureMerge.js';

export const BREAK_GLASS_FIXTURE_FLAG = 'wq_enrich_break_glass';

const BREAK_GLASS_KEY_RULES = { security: 'mergeObject', approvers: 'replaceIfEmpty' };

const EVT_004_DETAIL = {
  requester: { name: 'Marcus H.', role: 'Governance Lead', initials: 'MH' },
  requestedAt: 'Jun 17, 03:00 AM',
  incidentRef: 'IR-2026-0617',
  partition: 'PII — Identity Records',
  classification: 'Restricted — PII',
  accessScope: 'Read + Write',
  duration: '4 hours',
  reason:
    'Incident IR-2026-0617: Unauthorized access detected in identity partition. Requires immediate forensic review to assess scope and remediate.',
  security: {
    lastBreakGlass: '2026-05-02 by Devon N. — Approved — no incidents.',
    riskTier: 'Critical',
  },
  requiredCount: 2,
  approvers: [
    { id: 'devon-n', name: 'Devon N.', role: 'IT Security', initials: 'DN', status: 'pending' },
    { id: 'alexa-m', name: 'Alexa M.', role: 'Admin', initials: 'AM', status: 'pending' },
  ],
};

const EVT_004_THREAD = {
  status: 'open',
  comments: [
    {
      id: 'c1',
      author: 'Marcus H.',
      role: 'Governance Lead',
      initials: 'MH',
      timeAgo: '15d ago',
      body: 'Break Glass requested for IR-2026-0617. Two-key gate — awaiting IT Security and Admin sign-off (4-hour window).',
    },
  ],
};

export const BREAK_GLASS_DETAIL_FIXTURES = {
  'wq5096-breakglass-001': EVT_004_DETAIL,
  'wq5096-break-glass-001': EVT_004_DETAIL,
};

export const BREAK_GLASS_THREAD_FIXTURES = {
  'wq5096-breakglass-001': EVT_004_THREAD,
  'wq5096-break-glass-001': EVT_004_THREAD,
};

export function isBreakGlassFixtureEnabled() {
  if (!import.meta.env.DEV) return false;
  try {
    return localStorage.getItem(BREAK_GLASS_FIXTURE_FLAG) === '1';
  } catch {
    return false;
  }
}

export function mergeBreakGlassDetailFixture(contractId, detail = {}) {
  const fixture = BREAK_GLASS_DETAIL_FIXTURES[contractId];
  if (!fixture) return detail;
  return mergeFixtureDetail(detail, fixture, BREAK_GLASS_KEY_RULES);
}

export function applyBreakGlassDetailFixture(contractId, detail = {}) {
  if (!isBreakGlassFixtureEnabled()) return detail;
  return mergeBreakGlassDetailFixture(contractId, detail);
}

/** Thread seed for live break-glass contracts — gated by the same flag. */
export function getBreakGlassThreadFixture(eventId) {
  if (!isBreakGlassFixtureEnabled()) return null;
  return BREAK_GLASS_THREAD_FIXTURES[eventId] ?? null;
}
